<template>
    <crud-facecade
        ref="saftycheck-list"
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :tableHeight="tableHeight"
        :addButton="{ permission: 'saftyCheckConfig:create' }"
        :deleteButton="{ enabled: false, permission: 'saftyCheckConfig:delete' }"
        :updateButton="{ enabled: false, permission: 'saftyCheckConfig:edit' }"
        @reset="handleReset"
    >
    <template #filter>
        <el-col :md="8" :lg="5" :xl="5">
            <item-input type="select"  v-model="params.enum_safty_check_stage" :options="enumSaftyCheckStageList.map(item => ({ ...item, value: +item.value }))" clearable placeholder="核查阶段"></item-input>
        </el-col>
    </template>
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
const baseURL = `/api/AcisSystem/DicSaftyCheckItem`
export default {
    name: `DicSaftyCheckItem`,
    props: {},
    data() {
        return {
            title: Object.freeze(`安全核查配置`),
            url: {
                baseURL,
                getOne: (row) => {
                    return {
                        ...row,
                        enum_safty_check_stage: row.enum_safty_check_stage.split(`,`)
                    }
                },
                put: (data) => {
                    return this.myaxios.put(
                        `${baseURL}/Put`,
                        this.transformFormValues(data)
                    )
                },
                post: (data) => {
                    return this.myaxios.post(
                        `${baseURL}/Post`,
                        this.transformFormValues(data)
                    )
                },
                delete: (data) => {
                    return this.myaxios.put(
                        `${baseURL}/Put`,
                        {
                            ...data,
                            is_deleted: true
                        }
                    )
                }
            },
            buttons: [],
            enumSaftyCheckStageList: Object.freeze([
                { label: `麻前检查`, value: `1` },
                { label: `术前检查`, value: `2` },
                { label: `出室检查`, value: `3` }
            ]),
            datatypeoption: Object.freeze([
                { label: `文本框`, value: `string` },
                { label: `下拉框`, value: `select` },
                { label: `远程搜索下拉框`, value: `remoteselect` },
                { label: `远程搜索复选框`, value: `remotemultiselect` },
                { label: `单选框`, value: `radio` },
                { label: `选择框`, value: `checkbox` },
                { label: `组合复选框`, value: `checkboxgroup` },
                { label: `日期时间`, value: `datetime` },
                { label: `日期`, value: `date` },
                { label: `文本域`, value: `textarea` }]),
            params: {
                enum_safty_check_stage: undefined
            }
        }
    },
    computed: {
        ...mapGetters([`sys_enums`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    // width: "180",
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `multiselect`,
                    prop: `enum_safty_check_stage`,
                    label: `核查阶段`,
                    width: `160`,
                    sortable: true,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: this.enumSaftyCheckStageList,
                    showCount: 3,
                    config: {
                        collapseTags: false
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `显示名称`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `data_key`,
                    label: `CodeKey`,
                    width: `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `data_type`,
                    label: `字段类型`,
                    width: `150`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: this.datatypeoption,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `data_group_name`,
                    label: `分组名称`,
                    width: `150`,
                    isListable: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `data_option`,
                    label: `数据源`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `string`,
                    prop: `default_value`,
                    label: `默认值`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `string`,
                    prop: `rel_keys`,
                    label: `关联显示DataKey`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                }, {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `80`,
                    isListable: true,
                    isEditable: true,
                    searchable: true,
                    isCreatable: true
                }, {
                    type: `select`,
                    prop: `data_read_only`,
                    label: `是否只读`,
                    width: `120`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: false
                }, {
                    type: `select`,
                    prop: `data_required`,
                    label: `是否必填`,
                    width: `120`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: false
                }, {
                    type: `select`,
                    prop: `is_show`,
                    label: `是否默认显示`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: true
                }, {
                    type: `select`,
                    prop: `is_system_level`,
                    label: `是否系统级`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: false
                }, {
                    type: `select`,
                    prop: `position`, // right/left/top
                    label: `位置`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: [
                        { label: `right`, value: `right` },
                        { label: `left`, value: `left` },
                        { label: `top`, value: `top` }]
                }, {
                    type: `number`,
                    prop: `data_colspan`,
                    label: `宽度(24为4个字段)`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `120`,
                    readonly: false,
                    fixed: `right`,
                    isListable: true,
                    options: function(that, { row }) {
                        let r = [{
                            class: `is-plain`,
                            label: `编辑`,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `saftyCheckConfig:edit` // user:assignRole
                        },
                        {
                            class: `is-plain`,
                            label: `删除`,
                            type: `danger`,
                            emit: `DeleteData`,
                            permission: `saftyCheckConfig:delete` // user:assignRole
                        }]
                        console.log(`row`, row)
                        if (row.is_system_level == false) {
                            return r
                        }
                    }
                }
            ]
        }
    },
    watch: {
        "params.enum_safty_check_stage"() {
            this.$refs[`saftycheck-list`].ChangeCondition(this.params)
        }
    },
    methods: {
        handleReset() {
            this.params = {}
        },
        transformFormValues(data) {
            return {
                ...data,
                enum_safty_check_stage: data.enum_safty_check_stage.join(`,`)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Dictionary/SaftyCheck/Index.vue